import { MoreParameters } from "./MoreParameters";
import styles from "./parameterForms.module.css";
import { declaredDefault } from "./parameterValues";
import { SwitchParameter } from "./SwitchParameter";
import { TimestampControl } from "./TimestampControl";
import { TopicNameControl } from "./TopicNameControl";
import { type ParameterFormProps } from "./types";

const COVERED_KEYS = [
  "TIMESTAMP_COLUMN",
  "TIMESTAMP_UNIT",
  "TOPIC_NAME",
  "TOPIC_NAME_FROM_FILE_NAME_REGEX",
  "SKIP_INGESTED",
] as const;

/** Units in the short spelling this action documents. */
const PARQUET_UNITS = [
  { value: "s", label: "Seconds", aliases: ["seconds"] },
  { value: "ms", label: "Milliseconds", aliases: ["milliseconds"] },
  { value: "us", label: "Microseconds", aliases: ["microseconds"] },
  { value: "ns", label: "Nanoseconds", aliases: ["nanoseconds"] },
] as const;

/** `parquet_ingestion`: one Parquet file becomes one topic. */
export function ParquetIngestionForm(props: ParameterFormProps) {
  const { name, action, exampleFileName, startsOnUpload = false } = props;
  return (
    <div className={styles.form} data-testid="parameter-form-parquet_ingestion">
      <TimestampControl
        name={name}
        columnKey="TIMESTAMP_COLUMN"
        unitKey="TIMESTAMP_UNIT"
        units={PARQUET_UNITS}
        defaultUnit={declaredDefault(action, "TIMESTAMP_UNIT", "s") ?? "s"}
        detect={{
          label: "Detect from the Parquet schema",
          hint: "Works when a column has a TIMESTAMP logical type adjusted to UTC; otherwise pick the column and unit.",
        }}
      />
      <TopicNameControl
        name={name}
        exampleFileName={exampleFileName ?? "example.parquet"}
        fallsBackToFileName={false}
      />
      {/* A run that starts on an upload is handed a file nobody has ingested
          yet, so there is nothing to skip. A stored value is kept. */}
      {!startsOnUpload && (
        <SwitchParameter
          name={name}
          parameterKey="SKIP_INGESTED"
          label="Skip files already marked as ingested"
          defaultOn={
            (
              declaredDefault(action, "SKIP_INGESTED", "False") ?? "False"
            ).toLowerCase() === "true"
          }
          spelling="title"
        />
      )}
      <MoreParameters {...props} coveredKeys={COVERED_KEYS} />
    </div>
  );
}
